import {useEffect, useRef, useState} from 'react';

function useHorizontalScroll<T extends HTMLElement>() {
  const scrollRef = useRef<T>(null);
  const [isAtLeft, setIsAtLeft] = useState(true);
  const [isAtRight, setIsAtRight] = useState(false);
  const [isScrollable, setIsScrollable] = useState(false);

  function scrollListener() {
    if (scrollRef.current) {
      const scrollThreshold = 2;
      const scrollLeft = scrollRef.current.scrollLeft; // 현재 스크롤 위치 (좌우)
      const clientWidth = scrollRef.current.clientWidth; // 현재 컴포넌트 너비
      const scrollWidth = scrollRef.current.scrollWidth; // 전체 콘텐츠 너비

      setIsAtLeft(scrollLeft <= 0);
      setIsAtRight(scrollLeft + clientWidth >= scrollWidth - scrollThreshold);
      setIsScrollable(scrollWidth > clientWidth); // 스크롤 가능 여부
    }
  }

  function scrollToEnd() {
    if (scrollRef.current) {
      scrollRef.current.scrollTo({
        left: scrollRef.current.scrollWidth,
        behavior: 'smooth',
      });
    }
  }

  function scrollToStart() {
    if (scrollRef.current) {
      scrollRef.current.scrollTo({
        left: 0,
        behavior: 'smooth',
      });
    }
  }

  useEffect(() => {
    const currentRef = scrollRef.current;
    currentRef?.addEventListener('scroll', scrollListener);

    // 초기 스크롤 가능 여부 확인
    scrollListener();

    // 컴포넌트 언마운트 시 이벤트 리스너 제거
    return () => {
      currentRef?.removeEventListener('scroll', scrollListener);
    };
  }, []);

  return {scrollRef, isAtLeft, isAtRight, isScrollable, scrollToStart, scrollToEnd};
}

export default useHorizontalScroll;
